import { render, staticRenderFns } from "./RecipeOperate.vue?vue&type=template&id=8fc12b2a&scoped=true"
import script from "./RecipeOperate.vue?vue&type=script&lang=js"
export * from "./RecipeOperate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc12b2a",
  null
  
)

export default component.exports